import * as fromWbsDemandsV2 from "./demands.reducer";
import { IState } from "../reducers";
import { IWbsDemand } from "../../common/services/contracts/project.service.v2.contracts";

export const getDbDemandsState = (wbsId: string) => (store: IState): fromWbsDemandsV2.IDemandsState => store.db_demands[wbsId] ? store.db_demands[wbsId] : fromWbsDemandsV2.initialState;
export const getDbDemands = (wbsId: string) => (store: IState): IWbsDemand => getDbDemandsState(wbsId)(store).wbsDemands;
export const getDbDemandsLoading = (wbsId: string) => (store: IState): boolean => getDbDemandsState(wbsId)(store).loading;
export const getDbDemandsLoaded = (wbsId: string) => (store: IState): boolean => getDbDemandsState(wbsId)(store).loaded;
export const getDbDemandsError = (wbsId: string) => (store: IState): string => getDbDemandsState(wbsId)(store).error;
